import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { formatText } from 'core/i18n';
import { useEventListener } from '../../hooks/useEventListener';
import { useInterval } from '../../hooks/useInterval';
import { recordCallMeBack } from 'utilities/uTagging';
import { contactOfficerForm as ContactOfficerForm } from './contactOfficerForm.js';

const HelpTooltip = ({ userProfile, formActions, steps, style, addClass, hideIn }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [classCallMeBackMessage, setClassCallMeBackMessage] = useState('hidden');
    const [lastScrollTop, setLastScrollTop] = useState(window.pageYOffset || document.documentElement.scrollTop);
    const [tooltipUserHelpClassName, setTooltipUserHelpClassName] = useState('');
    const [classCallMeBackShake, setClassCallMeBackShake] = useState('');
    const [classCallMeBackWrapperShake, setClassCallMeBackWrapperShake] = useState('');
    const [mobile, setMobile] = useState(false);

    const {
        interval: tooltipInterval,
        clearInterval,
        initInterval,
    } = useInterval({
        initOnStart: false,
        timer: 20000,
        action: () => {
            if (!showTooltip) {
                setClassCallMeBackMessage('cmb-message');
                setClassCallMeBackShake('user-help--alert');
                setClassCallMeBackWrapperShake('cmb-wrapper--shake');
            }
        },
    });

    const handleResize = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setMobile(width <= 768);
    };

    useEventListener('resize', handleResize);
    useEventListener('scroll', () => {
        clearTimer();
        if (mobile) {
            const st = window.pageYOffset || document.documentElement.scrollTop;
            setLastScrollTop(st);
            setTooltipUserHelpClassName(st > lastScrollTop ? 'cmb-wrapper--hide' : '');
            setTooltipUserHelpClassName('');
        }
    });

    useEffect(() => {
        document.addEventListener('click', handleCloseHelper);

        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        handleResize();
        if (width >= 765) {
            initTimer();
        }

        return () => {
            document.addEventListener('click', handleCloseHelper);
        };
    }, []);

    useEffect(() => {
        const checkHeight = () => {
            const element = document.querySelector('.contact-officer__body');
            const parent = document.querySelector('.form__help-tooltip__popup');
            if (parent && element) {
                const parentRect = parent.getBoundingClientRect();

                if (parentRect.top < 30) {
                    parent.style.top = '30px';
                    parent.style.maxHeight = `calc(100vh - 30px)`;
                } else if (element.scrollHeight > element.clientHeight) {
                    parent.style.top = '30px';
                    parent.style.maxHeight = '';
                } else {
                    parent.style.top = '';
                    parent.style.maxHeight = '';
                }
            }
        };

        if (mobile) {
            document.documentElement.style.overflowY = `${showTooltip ? 'hidden' : 'unset'}`;

            const parent = document.querySelector('.form__help-tooltip__popup');
            parent.style.top = '';
            parent.style.maxHeight = '';

            window.removeEventListener('resize', checkHeight);
        } else {
            checkHeight();
            window.addEventListener('resize', checkHeight);
        }

        return () => {
            window.removeEventListener('resize', checkHeight);
        };
    }, [showTooltip, mobile]);

    const handleOnKeyDown = () => {
        clearTimer();
    };

    useEventListener('keydown', handleOnKeyDown);

    const initTimer = () => {
        if (!tooltipInterval && !mobile) {
            initInterval();
        }
    };

    const clearTimer = () => {
        if (tooltipInterval && !mobile) {
            setClassCallMeBackMessage('hidden');
            setClassCallMeBackShake('');
            setClassCallMeBackWrapperShake('');
            clearInterval();
            initTimer();
        }
    };

    const handleClose = () => {
        if (!showTooltip) return;

        formActions.reset('userProfile.contactFullName');
        formActions.reset('userProfile.contactPhone');
        formActions.reset('userProfile.contactCheck');
        formActions.reset('userProfile.contactCheckBox');
        formActions.reset('userProfile.contactCountryCode');
        formActions.change('userProfile.contactCountryCode', '+34');
        document.getElementById('contactFullName').value = '';
        document.getElementById('contactPhone').value = '';

        if (
            typeof userProfile.acceptTerms !== 'undefined' &&
            userProfile.acceptTerms &&
            steps.get('initialStepComplete')
        ) {
            formActions.change('userProfile.contactCheck', true);
            formActions.change('userProfile.contactCheckBox', true);
            formActions.setValidity('userProfile.contactCheck', { required: true });
            formActions.setValidity('userProfile.contactCheckBox', { required: true });
        }
        mobile && setShowTooltip(false);
    };

    function handleCloseHelper(event) {
        if (mobile) return;
        if (!event.target.classList.contains('user-help') && !event.target.closest('.form__help-tooltip__popup')) {
            setShowTooltip(false);
        }
    }

    const handleClick = () => {
        const { investmentType } = userProfile;
        const loggedIn = typeof userProfile.userId !== 'undefined';
        clearTimer();
        setShowTooltip(prevState => !prevState);
        recordCallMeBack(loggedIn, 'acceso', '', investmentType ? investmentType : '');
    };

    const handleClickOnHelpText = () => {
        clearTimer();
        setShowTooltip(prevState => !prevState);
    };

    const inArray = (needle, haystack) => {
        const length = haystack.length;
        for (let i = 0; i < length; i++) {
            if (haystack[i] === needle) return true;
        }

        return false;
    };

    const buildToolTip = () => {
        const classTooltip = `form__help-tooltip__popup ${showTooltip ? '' : 'form__help-tooltip__popup--hidden'}`;
        const className = `form__help-tooltip ${addClass}`;
        const userClassName = `cmb-wrapper ${classCallMeBackWrapperShake} ${tooltipUserHelpClassName} `;
        const classUserHelp = `user-help ${classCallMeBackShake}`;

        return (
            <div className={className} style={style}>
                <div className={classTooltip} id="tooltipPopupFixed">
                    {showTooltip && <ContactOfficerForm handleClose={handleClose} />}
                </div>
                <div className={userClassName}>
                    <div className={classUserHelp} onClick={handleClick}></div>
                    <div className={`hidden-xs ${classCallMeBackMessage}`} onClick={handleClickOnHelpText}>
                        <span className="cmb-wrapper__tooltip">{`${formatText('tooltip-needHelp')}`}</span>{' '}
                        <span className="arrow-right"></span>
                    </div>
                </div>
            </div>
        );
    };

    if (!hideIn || !inArray(window.location.pathname, hideIn)) {
        return buildToolTip();
    }

    return <div />;
};
HelpTooltip.defaultProps = {
    style: {},
    addClass: '',
    hideIn: [],
};

module.exports.constructor = HelpTooltip;
module.exports.HelpTooltip = connect(
    state => ({
        userProfile: state.userProfile,
        steps: state.steps,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
    })
)(HelpTooltip);
